import $ from 'jquery';
import 'slick';
import { 
    slickCommonOptions,
} from './../../scripts/config';

/**
 * ProductSwitcherV1 widget configs
 */
const productSwitcherV1Semantics = {
    'mainWrapClass': 'product-switcher-v1',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'activeElement': 'product-switcher-v1__preview-item',
};

/**
 * ProductSwitcherV1 initializer
 */
$(function () {
    ProductSwitcherV1.init();
});

class ProductSwitcherV1 {
    constructor() {
        this.pluginInstances = {};
    }

    static init() {
        if ($(`.${productSwitcherV1Semantics.mainWrapClass}`).length === 0) {
            return false;
        }

        if (!window || !window.widgets || !window.widgets.productSwitcherV1) {
            window.widgets.productSwitcherV1 = new ProductSwitcherV1();
        }

        /**
         * Checking other instances
         */
        $(`.${productSwitcherV1Semantics.mainWrapClass}`).each((index, el) => {
            let isInitialized =
                ($(el).attr(productSwitcherV1Semantics.isInitializedAttribute) === 'true');
            if (!isInitialized) {
                window.widgets.productSwitcherV1.registerInstance($(el));
                window.widgets.productSwitcherV1.registerListeners($(el));
            }
        });
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${productSwitcherV1Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        let commonPluginOptions =
            el.data(
                `${productSwitcherV1Semantics.commonPluginOptionsAttribute}`.replace('data-', '')
            ) || {};


        let pluginOptions = Object.assign({},
            slickCommonOptions,
            commonPluginOptions,
            {
                arrows: false,
                variableWidth: true,
                mobileFirst: true,
                swipeToSlide: true,
                centerMode: false,
                adaptiveHeight: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: false,
                speed: 0,
                focusOnSelect: false,
            }
        );

        try {
            let slick = el.slick(pluginOptions);
            el.show();
            el.attr(`${productSwitcherV1Semantics.isInitializedAttribute}`, true);
            window.widgets.productSwitcherV1.pluginInstances[instanceId] = slick;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el) {

    }


    reInit(instanceId) {
        ProductSwitcherV1.init();
    }
}